const BASE_INITIAL_STATE = {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
};

export const utenteInitialState = {
    profilo: window.datiUtente,
    ufficioSelezionato: window.ufficioSelezionato,
};

export const applicationInitialState = {
    isLoadingApplication: false,
};

export const dichiarativiInitialState = {
    annoSelezionato: 0,
    anniRegistrati: { ...BASE_INITIAL_STATE },
};
